import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { useSeo } from "@/lib/site";
import { useAuth } from "./AuthContext";
import { Logo } from "@/components/brand/Logo";

export default function AdminLogin() {
  useSeo("Admin sign in");
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      navigate(location.state?.from || "/admin", { replace: true });
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-5 bg-cream">
      <form onSubmit={submit} className="card-soft !bg-white w-full max-w-md p-8 space-y-5" data-testid="admin-login-form">
        <Logo />
        <h1 className="text-3xl">Administrator sign in</h1>
        <p className="text-sm text-ink-soft">Private area for authorised Addiction &amp; Us staff only.</p>
        <div><label htmlFor="admin-email" className="field-label">Email</label><input id="admin-email" type="email" className="field" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" data-testid="admin-login-email-input" /></div>
        <div><label htmlFor="admin-password" className="field-label">Password</label><input id="admin-password" type="password" className="field" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" data-testid="admin-login-password-input" /></div>
        {error && <p role="alert" className="text-clay-dark font-semibold" data-testid="admin-login-error">{error}</p>}
        <button type="submit" className="btn-primary w-full" disabled={busy} data-testid="admin-login-submit-button">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}
